<template>
  <v-app id="jns" toolbar footer>
    <JNSMenu v-if="displayMenu" />

    <router-view />
    <modal-helpers />
    <form-alert-full-block v-if="appBlockCriteria">
      <p class="mb-0">
        <a class="block" href="javascript:location.reload()" style="color: #fff;">
          Clique aqui para atualizar a página
        </a>
      </p>
    </form-alert-full-block>
  </v-app>
</template>

<script>
import moment from "moment";
import { isWorkingHours } from "@/libs/datetime";
import axios from "axios";
import JNSMenu from "@/components/JNSMenu";

const urls = ["localhost", "stage.portal.jnsseguros.com.br"];

const dontShowMenu = [
  "Login",
  "Termos de Serviço",
  "Criar Senha",
  "Bloquear Usuários",
  "Cadastrar"
];

export default {
  name: "app",
  components: {
    JNSMenu,
  },

  data() {
    return {
      desabilitaLogin: false,
      mostraMensagemBloqueio: false,
      intervaloHorarioAtendimento: false,
      alertText: {},
    };
  },

  mounted() {
    this.init();
  },

  destroyed() {
    clearInterval(this.intervaloHorarioAtendimento);
  },

  computed: {
    displayMenu() {
      return !dontShowMenu.includes(this.$route.name);
    },
    appBlockCriteria() {
      const { name } = this.$route;
      return (name == 'Login' && this.desabilitaLogin) ||
        (name != 'Login' && this.mostraMensagemBloqueio);
    }
  },

  methods: {
    async init() {
      if (urls.filter(this.ativaHorarioAtendimento).length == 0) {
        this.horarioAtendimento();
        this.intervaloHorarioAtendimento = setInterval(
          this.horarioAtendimento,
          15000
        );
      }
    },

    ativaHorarioAtendimento(url) {
      return window.location.hostname == url;
    },

    horarioAtendimento() {
      const now = moment();
      const notWorkingHours  = !isWorkingHours(now);

      this.mostraMensagemBloqueio = notWorkingHours;
      this.desabilitaLogin = notWorkingHours;
      this.$forceUpdate();

      if (notWorkingHours && this.$route.name != "Login") {
        localStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        this.$router.push({ name: "Login" });
      }
    },
  },
};
</script>

<style lang="scss">
@import "assets/main.scss";
.lowercase {
  text-transform: lowercase;
  input {
    text-transform: lowercase;
  }
}
.uppercase {
  text-transform: uppercase;
}
main .container {
  margin-left: 0;
}
.no-padding {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// ./src/App.vue